import styled from 'styled-components'
import { Button, Col, Select } from 'antd'

const ContainerTable = styled.div`
  padding: 4%;
`
const StyledSelect = styled(Select)`
  width: 100%;
`

const ActionButton = styled(Button)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  &.accept {
    background-color: ${props => props.theme.green} !important;
    :hover {
      background-color: ${props => props.theme.greenHover} !important;
    }
  }
  &.decline {
    background-color: ${props => props.theme.red} !important;
    :hover {
      background-color: ${props => props.theme.redHover} !important;
    }
  }
  &.invoice {
    svg {
      fill: white;
      font-size: 1.3125rem;
    }
    background-color: ${props => props.theme.blue} !important;
    &:hover {
      background-color: ${props => props.theme.blueHover} !important;
    }
  }
  &.hide {
    svg {
      fill: white;
      font-size: 1.3125rem;
    }
    background-color: ${props => props.theme.gray} !important;
    &:hover {
      background-color: ${props => props.theme.secondaryDarkGray} !important;
    }
  }
`

const ActionButtonCustom = styled(Button)`
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  outline: none;
  box-shadow: none;
`

const StyledLink = styled.a`
  height: fit-content;
  line-height: 1;
`

const StyledCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export { ContainerTable, StyledSelect, ActionButton, ActionButtonCustom, StyledLink, StyledCol }
export { AcceptTicketModal } from './AcceptTicketModal'
export { DeclineTicketModal } from './DeclineTicketModal'
export { TicketCard } from './TicketCard'
export { MobileFilters } from './MobileFilters'
export { AddTruckModal } from './AddTruckModal'
export { EditTruckModal } from './EditTruckModal'
export { ViewTruckModal } from './ViewTruckModal'
export { AddDriverModal } from './AddDriverModal'
export { EditDriverModal } from './EditDriverModal'
export { ViewDriverModal } from './ViewDriverModal'
